import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

interface ContentSectionProps {
  title?: string
  subtitle?: string
  children: ReactNode
  className?: string
  centered?: boolean
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "7xl" | "full"
  spacing?: "tight" | "normal" | "relaxed"
}

export function ContentSection({
  title,
  subtitle,
  children,
  className,
  centered = false,
  maxWidth = "3xl",
  spacing = "normal",
}: ContentSectionProps) {
  // Map spacing options to Tailwind classes
  const spacingClasses = {
    tight: "space-y-3",
    normal: "space-y-6",
    relaxed: "space-y-8",
  }

  // Map max width options to Tailwind classes
  const maxWidthClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    "3xl": "max-w-3xl",
    "4xl": "max-w-4xl",
    "5xl": "max-w-5xl",
    "6xl": "max-w-6xl",
    "7xl": "max-w-7xl",
    full: "max-w-full",
  }

  return (
    <div className={cn("w-full mx-auto", maxWidthClasses[maxWidth], centered && "text-center", className)}>
      {title && <h2 className="text-3xl font-bold text-gray-900 mb-4 tracking-tight font-funnel">{title}</h2>}
      {subtitle && <p className="text-xl font-medium text-gray-600 mb-6">{subtitle}</p>}
      <div className={cn("text-gray-600", spacingClasses[spacing])}>{children}</div>
    </div>
  )
}
